import { render, staticRenderFns } from "./defaultValue-editor.vue?vue&type=template&id=5fa60046&scoped=true"
import script from "./defaultValue-editor.vue?vue&type=script&lang=js"
export * from "./defaultValue-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa60046",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fa60046')) {
      api.createRecord('5fa60046', component.options)
    } else {
      api.reload('5fa60046', component.options)
    }
    module.hot.accept("./defaultValue-editor.vue?vue&type=template&id=5fa60046&scoped=true", function () {
      api.rerender('5fa60046', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/defaultValue-editor.vue"
export default component.exports